import { Skeleton, Typography } from 'antd'
import { Suspense } from 'react'

import { Users } from './Users'

export const UsersPage = () => (
  <>
    <Typography.Title>Users</Typography.Title>

    <Suspense fallback={<Skeleton />}>
      <Users />
    </Suspense>
  </>
)
